import { useEffect } from 'react';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./firebaseConfig";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Home from "./Component/Authenticated/Home/Home";
import ReactGA from 'react-ga';

initializeApp(firebaseConfig);

const App = () => {
  useEffect(() => {
    ReactGA.initialize("UA-222718068-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
};

export default App;
